import {
    normalizeFetchAttachableProblemsResponse,
    normalizeFetchProblemSetDetailsResponse,
    normalizeFetchProblemSetGradesResponse,
    normalizeFetchProblemSetsResponse,
} from './utils/normalizers/problem-sets.normalizers'
import { ASSIGNMENT_TAG, createTagsForList, PROBLEM_SET_TAG } from './utils/tags'
import baseApi from './base.api'

export const problemSetsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchProblemSets: builder.query({
            query: () => ({
                url: '/problem-sets/',
                method: 'GET',
                params: { is_own: true },
            }),
            transformResponse: normalizeFetchProblemSetsResponse,
            providesTags: result => createTagsForList(result, PROBLEM_SET_TAG),
        }),
        fetchProblemSetDetails: builder.query({
            query: ({ id }) => ({
                url: `/problem-sets/${id}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchProblemSetDetailsResponse,
            providesTags: (result, error, arg) => [{ type: PROBLEM_SET_TAG, id: arg.id }],
        }),
        fetchAttachableProblems: builder.query({
            query: () => ({
                url: '/assignments/get-attachable-assignments',
                method: 'GET',
                params: { is_own: true },
            }),
            transformResponse: normalizeFetchAttachableProblemsResponse,
            providesTags: result => createTagsForList(result, ASSIGNMENT_TAG),
        }),
        createProblemSet: builder.mutation({
            query: ({ name, instructions }) => ({
                url: '/problem-sets/',
                method: 'POST',
                body: { name, instructions },
            }),
            invalidatesTags: [{ type: PROBLEM_SET_TAG, id: 'LIST' }],
        }),
        updateProblemSet: builder.mutation({
            query: ({ id, name, problems, instructions }) => ({
                url: `/problem-sets/${id}`,
                method: 'PUT',
                body: { name, assignment_ids: problems, instructions },
            }),
            invalidatesTags: (result, error, arg) => [{ type: PROBLEM_SET_TAG, id: arg.id }],
        }),
        deleteProblemSet: builder.mutation({
            query: ({ id }) => ({
                url: `/problem-sets/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: PROBLEM_SET_TAG, id: 'LIST' }],
        }),
        fetchProblemSetGrades: builder.query({
            query: ({ id, page }) => ({
                url: `/problem-sets/${id}/export-grades`,
                method: 'GET',
                params: { page },
            }),
            transformResponse: normalizeFetchProblemSetGradesResponse,
            providesTags: (result, error, arg) => [{ type: PROBLEM_SET_TAG, id: arg.id }],
        }),
        downloadProblemSetGrades: builder.query({
            query: ({ id }) => ({
                url: `/problem-sets/${id}/export-grades`,
                method: 'GET',
                params: {
                    response_format: 'csv',
                },
                responseType: 'blob',
            }),
            providesTags: (result, error, arg) => [{ type: PROBLEM_SET_TAG, id: arg.id }],
        }),
    }),
})

export const {
    useFetchProblemSetsQuery,
    useFetchProblemSetDetailsQuery,
    useFetchAttachableProblemsQuery,
    useCreateProblemSetMutation,
    useUpdateProblemSetMutation,
    useDeleteProblemSetMutation,
    useFetchProblemSetGradesQuery,
    useLazyDownloadProblemSetGradesQuery,
} = problemSetsApi
